import React from 'react';

export function TrophyIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" {...props}>
            <path
                fill="currentColor"
                d="M18 5.062V3H6v2.062H2V8c0 2.525 1.889 4.598 4.324 4.932A6 6 0 0 0 11 16.91V18a2 2 0 0 1-2 2H8v2h8v-2h-1a2 2 0 0 1-2-2v-1.09a6 6 0 0 0 4.676-3.978C20.111 12.598 22 10.525 22 8V5.062zM4 8v-.938h2v3.766A3 3 0 0 1 4 8m16 0a3.01 3.01 0 0 1-2 2.829V7.062h2z"></path>
        </svg>
    );
}
